import { Container, Box } from "@mui/material";
import Footer from "./Footer";
import { useUrlParams } from "hooks/useUrlParams";
import { useTheme } from "@emotion/react";

function AppLayout({ children, page, width }) {
  const { contentWork } = useUrlParams();
  const theme = useTheme();

  const backgroundStyles = theme.backgroundStyles[page]
    ? theme.backgroundStyles[page]
    : {
        backgroundImage: `url(/${contentWork}/pattern.jpg)`,
        backgroundSize: "100% auto",
        backgroundRepeat: "repeat",
        backgroundPosition: "top center",
      };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...backgroundStyles,
      }}
    >
      <Container
        sx={{
          width: width || "84%", // 幅を84%に設定
          minHeight: "100vh",
          margin: 0,
          padding: 0,
        }}
      >
        {children}
      </Container>
      <Footer />
    </Box>
  );
}

export default AppLayout;
